// @flow

import * as React from 'react';
import {Text} from 'sail/Text';
import {DocsIcon} from 'docs/components';
import {usePersistentState} from 'docs/data';
import type {VideoModel} from 'docs/data';

type PlaylistVideoStatusProps = {|
  video: VideoModel,
  index: number,
  selectedVideo: VideoModel,
|};

export const PlaylistVideoStatus = ({
  video,
  index,
  selectedVideo,
}: PlaylistVideoStatusProps) => {
  const indexName = `video-progress-${video.youtubeId}`;
  const [videoProgress] = usePersistentState<number>(indexName, 0);
  const duration = video.duration || 0;
  const timeLeft = duration - videoProgress;

  if (video.id === selectedVideo.id) {
    // If the video we're currently viewing is this row, then show the checkmark.
    return <DocsIcon category="general" icon="bluecheckmark" size={16} />;
  } else if (timeLeft < 15) {
    // If the user has less than 15 seconds left of the video, we consider it "watched."
    return (
      <Text size={11} className="Watched-badge">
        Watched
      </Text>
    );
  } else {
    // The user hasn't completed this video yet, so we render the index in the playlist.
    return index + 1;
  }
};
